import { IconRenderer } from "../../../helper/components/IconRenderer.js";
import styles from "./BaseCardLabel.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BaseCardLabel({
  labelText,
  labelIcon
}) {
  if (!labelText) {
    return null;
  }
  return /*#__PURE__*/_jsxs("label", {
    className: styles.label,
    children: [labelIcon && /*#__PURE__*/_jsx(IconRenderer, {
      icon: labelIcon,
      size: "SMALL"
    }), labelText]
  });
}